export default __webpack_public_path__ + "static/8-principles-handout-DEC2020-2982d6a007f29eba1f5c113a6e95ce78.pdf";